import React, { useState } from 'react'
import { useSpring, animated } from 'react-spring'

import PropTypes from 'prop-types'

import { VimePlayer, VimeAudio, VimeDefaultUi } from '@vime/react'

import '@vime/core/themes/default.css'
import '@vime/core/themes/light.css'

import { isAudio } from '../utils'
import EpisodeMeta from './EpisodeMeta'

const Episode = (props) => {
  const [showsSummary, setShowsSummary] = useState(false)

  const { transform, opacity } = useSpring({
    opacity: showsSummary ? 1 : 0,
    transform: `perspective(800px) rotateX(${showsSummary ? 0 : 180}deg)`,
  })

  const playerProps = useSpring({
    transform: `perspective(800px) translateZ(${showsSummary ? -100 : 0}px`,
    bottom: 0,
    opacity: showsSummary ? 0 : 1,
  })

  const inverseTransform = transform.interpolate((t) => `${t} rotateX(180deg)`)
  const inverseOpacity = opacity.interpolate((o) => 1 - o)

  const renderMedia = props.enclosures.filter(isAudio).map((media) => {
    return (
      <div className='text-center flex-fill' key={media.url}>
        <VimePlayer
          className='text-center w-100 d-block'
          theme='light'
          data-testid='episode'
        >
          <VimeAudio>
            <source src={media.url} type={media.type} />
          </VimeAudio>
          <VimeDefaultUi />
        </VimePlayer>
      </div>
    )
  })

  return (
    <div className='card'>
      <div
        onClick={() => setShowsSummary(!showsSummary)}
        style={{ borderRadius: 'var(--bs-card-border-radius)' }}
        className='bg-white text-left cursor-pointer'
      >
        <animated.div
          style={{ transform: inverseTransform, opacity: inverseOpacity }}
          className=''
        >
          <div className='card-content-wrapper mb-5'>
            <div className='row g-0'>
              <div className='col-md-4 col-lg-2'>
                <div className='card-body'>
                  <img
                    src={props.image}
                    className='x-card-img-top img-fluid'
                    alt='episode logo'
                    width='500'
                    height='500'
                  />
                </div>
              </div>
              <div className='col-md-8 col-lg-10'>
                <div className='card-body'>
                  <div className='h5 card-title mb-2'
                       dangerouslySetInnerHTML={{__html: props.title}} />
                  <p className='card-text lead mb-2'>{props.subtitle}</p>
                  <p className='small text-body-secondary'>
                    <EpisodeMeta
                      duration={props.duration}
                      published={props.published}
                      authors={props.authors}
                    />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </animated.div>
        <animated.div
          style={{
            opacity,
            transform,
            borderRadius: 'var(--bs-border-radius)',
          }}
          className='p-4 position-absolute top-0 left-0 bottom-0 right-0 bg-white d-flex flex-column justify-content-center'
        >
          <i className='bi bi-arrow-left-circle fs-4 position-absolute' />
          <p
            className='card-text ms-5 m-sm-5'
            style={{ overflowY: showsSummary ? 'auto' : 'hidden' }}
          >
            {props.summary}
          </p>
        </animated.div>
      </div>
      <animated.div style={playerProps} className='position-absolute w-100'>
        <div
          className='card-footer d-flex flex-row align-items-center gap-2'
        >
          {renderMedia}
          <button
            type='button'
            className='text-dark bg-transparent border-0'
            onClick={() => setShowsSummary(!showsSummary)}
            aria-label='Episode Summary'
          >
            <i className='bi bi-info-circle-fill d-block' />
          </button>
        </div>
      </animated.div>
    </div>
  )
}

Episode.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  summary: PropTypes.string.isRequired,
  published: PropTypes.string.isRequired,
  enclosures: PropTypes.array.isRequired,
  authors: PropTypes.array.isRequired,
  image: PropTypes.string.isRequired,
  duration: PropTypes.string.isRequired,
}

export default Episode
